import React, { PureComponent } from 'react';
import {Table} from 'antd';
import PropTypes from "prop-types";
import dayjs from 'dayjs';
// import {connect} from "react-redux";
import { isEmptyObject,toFixed2,formatNumberToPrice} from '../../utils/utils';
import Lang from "../Lang/Lang";
import './index.less'

/**
 * 表格组件
 * @author FJJ
 * @version 1.0
 *
 * 必传 的 参数
 * columns 栏目:[{
 *          cnTitle：lang的默认显示值
 *          cnTitleId: lang 对应KEY
 *          dataIndex: 数据读取ID，
 *          key: lang的Key值
 *          title: 官方参数，无传 cnText 时，显示 title 内容
 *          type:'timestampToDate' 可选渲染类型，时间戳转日期，默认'YYYY-MM-DD',
 *              'money' 价格显示格式，带千位符，默认'，'
 *      }]
 * fetchFunction 查询方法 须带回调
 * onRef 组件通讯使用，绑定后调用 handleFetch 重新获取数据
 *
 * 辅助参数
 * initFetch 进入是否查询 默认为true
 * fetchCondition 搜索条件
 * footer 底部 默认否
 * size 尺寸
 * rowClassName 表格行类名
 * rowSelection 选择行 默认null
 * paginationFlag 是否显示页码 默认 true
 *
 * 待扩展：todo 暂无 redux 未处理
 * 显示相关 columns中传入配置
 * 
 * type 显示类型
 * enumClass 若type=='Enum' 则须配置枚举类取字典数据配合显示
 * @copyright 2021-2021, all rights reserved. Essa.cn
 **/
class FetchTable extends PureComponent {
    static propTypes = {
        columns: PropTypes.array.isRequired,
        fetchFunction: PropTypes.func.isRequired,
        onRef: PropTypes.func.isRequired,
        initFetch: PropTypes.bool,
        fetchCondition: PropTypes.object,
        footer: PropTypes.func,
        size: PropTypes.string,
        rowClassName: PropTypes.string,
        rowSelection: PropTypes.any,
        scroll: PropTypes.object,
        paginationFlag: PropTypes.bool,
        pageSize: PropTypes.number,
        rowKey: PropTypes.string,
    }
    static defaultProps = {
        columns: [],
        initFetch: true,
        fetchCondition:{},
        size:'default',
        rowClassName:'editable-row',
        rowSelection: null,
        paginationFlag: true,
        pageSize:50,
        rowKey:''
    };
    constructor(props) {
        super(props);
        this.handleColumns = this.handleColumns.bind(this)
        this.state = {
            columns: props.columns ? this.handleColumns(props.columns) : [],
            current: props.current ? props.current : 1,
            pagination: props.pagination ? props.pagination : {
                showQuickJumper: true,
                pageSize:props.pageSize,
                current: props.pageNum||1,
            },
            loading: false,
            size: props.size,
            rowClassName: props.rowClassName,
            lastSearch: {}, //上一次的搜索条件
        }
    }
    //处理栏目
    handleColumns(formatColumns){
        if(formatColumns&&formatColumns.constructor === Array){
            // const { dictionary } = this.props;
            formatColumns.forEach((column,i) => {
                if(column.cnTitleId){
                    let titleStr ='';
                    if(column.cnTitleId.constructor===Array){
                        const list = column.cnTitleId;
                        list.forEach((item,index)=>titleStr += Lang({id: item, default: column.cnTitle[index]})+'/');
                        titleStr = titleStr.substr(0,titleStr.length-1);
                    }else titleStr = Lang({id: column.cnTitleId, default: column.cnTitle});
                    column.title =titleStr;
                }
                if(column.type&&column.type=='timestampToDate'){
                    column['render'] = (timestamp, record) => dayjs(timestamp).format('YYYY-MM-DD');
                }
                if(column.type&&column.type=='money'){
                    column['render'] = (num, record) =>formatNumberToPrice(toFixed2(num),',',true);
                }
            })
        }
        return formatColumns;
    }
    /**
     * 切换页面
     * @param pagination 页码数据
     * @param filters 筛选
     * @param sorter  排序
     */
    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        const { lastSearch } = this.state; //点击页面带当前搜索条件
        const currentSearch = {
            ...lastSearch,
            pagingQuery:{
                pageIndex: pagination.current,
                pageSize: pagination.pageSize
            },
            // pageSize: pagination.pageSize,
            // pageNo: pagination.current,
            // sortField: sorter.field,
            // sortOrder: sorter.order,
            ...filters,
        };
        this.setState({
            pagination: pager,
        });
        this.handleFetch(currentSearch);
    }
    /**
     * 查询并加载数据
     * @param params  查询参数
     * @param flagUseLastSearch  是否采用上次的搜索条件
     */
    handleFetch = (params = {}, flagUseLastSearch = false) => {
        // console.log('handleFetch params',params)
        this.loading(true)
        if(flagUseLastSearch){
            const { lastSearch } = this.state;
            params = { ...lastSearch}
        }else {
            this.setState({
                lastSearch : params
            })
        }
        if(isEmptyObject(params.pagingQuery)){
            const {current,pageSize } = this.state.pagination;
            params.pagingQuery = {
                pageIndex: current,
                pageSize: pageSize
            }
        }
        this.props.fetchFunction(params,(res)=>this.loadingListRes(res))
    }
    /**
     * 查询结果
     * @param res
     */
    loadingListRes(res){
        this.loading(false)
        if(res&&res.status==200&&res.data){
            const data = res.data.models||[];
            const paging = res.data.paging||{};
            const {pagination} = this.state;
            this.setState({
                list: data.constructor===Array?data:[],
                pagination:{
                    ...pagination,
                    total: paging.total,
                    pageSize:paging.pageSize,
                    current: paging&&paging.pageNum?paging.pageNum:1
                },
            })
            window.scrollTo(0, 0);
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 进入 加载数据 列表
     */
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
        if(this.props.initFetch){
            let fetchCondition = {};
            if(this.props.fetchCondition)fetchCondition=this.props.fetchCondition;
            this.handleFetch(fetchCondition);
        }
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { loading, list, size, rowClassName, pagination } = this.state;
        const {rowKey}=this.props;
        const paginationFlag = this.props.paginationFlag;
        return (<div className={'TableWrap'}>
            <Table
            columns={ this.state.columns }  //栏目
            rowKey={record => rowKey?record[rowKey]:(record.id||record._id)}    // KEY
            dataSource={list}  // 数据源
            pagination={paginationFlag?pagination:paginationFlag}         //页码
            loading={loading}    //加载
            onChange={this.handleTableChange} // 点击切换页码事件

            rowSelection={this.props.rowSelection ? this.props.rowSelection : null}  // 勾选框
            rowClassName= {rowClassName} //表格行的类名
            size = {size}        //大小
            footer={ this.props.footer }      //底部默认null
        />
            </div>);
    }
}
// const mapState=(state)=>({
//     dictionary:state.getIn(["global","dictionary"]).toJS(),
// });
// const mapDispatch=(dispatch)=>({
//
// });
// export default connect(mapState, mapDispatch,null,{ forwardRef: true })(FetchTable);


export default FetchTable;